export default __webpack_public_path__ + "static/media/arrow_forward_blue.39c12837.png";